import React, { useState } from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'

// Componentes
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import BonusExclusivos from './Components/BonusExclusivos/BonusExclusivos'
import Planos from './Components/Planos/Planos'

export default function RenovacaoAntecipada2026 () {

	return (
		<UserDetails showSpinner>
			{details => {

				const [data] = useState(details.blackfriday)				

				let planosInitial = data.planos;

				return (
					<ContainerGeral padding={false}>
						
						{/* Banner Principal */}
						<BannerPrincipal nome={details.name} desconto={data.desconto_ate} dataFim={data.data_fim} />

						{/* Planos */}
						<Planos planos={planosInitial} />

						{/* Bônus Exclusivos */}
						<BonusExclusivos planos={planosInitial} dataFim={data.data_fim} />
	
					</ContainerGeral>
				)
				
			}}
		</UserDetails>
	)
}
